import BaseAPI, { ROUTES, VERSIONS } from './BaseAPI'

const { VERSION_TWO } = VERSIONS
const { SEARCH_QUERY } = ROUTES

export default class SearchAPI extends BaseAPI {
  async query(options) {
    const { version=VERSION_TWO } = super.getVersion(SEARCH_QUERY)

    const res = await this.httpClient.post('/:version/search', {
      data: options,
      urlParams: {
        version,
      }
    })

    return res.data
  }

  async patientQuery(options) {
    const res = await this.httpClient.post('/v5/patient/search', {
      data: options,
    })

    return res.data
  }
}
